export default __webpack_public_path__ + "assets/svg/5f9d6a5428d60044b9383e891cde3359.svg";